import { computed } from 'vue';
import { canUseMessageHub as canUseMessageHubUtil } from '~/components/message-hub/messageHubUtil';
import { SENDER_TYPE_CORPORATE, SENDER_TYPE_GROUP } from '~/constants/senderTypes';

// TODO: Rename to something else, no longer only related to group
export const useCurrentGroup = () => {
    const getCurrentGroupId = () => {
        return Spark.state.currentGroup?.group_id;
    };

    // TODO: move to computed, remember to move all usage on <script> tags to include `.value`
    const roleOnCurrentGroup = Spark?.roleOnCurrentGroup;
    const roleOnCurrentOrgUnit = Spark?.roleOnCurrentOrgUnit;

    const currentGroup = computed(() => Spark.state.currentGroup);
    const currentOrgUnit = computed(() => Spark.state.currentOrgUnit);

    const onCorporate = () => {
        return !currentGroup.value?.group_id && !currentOrgUnit.value?.id;
    };

    const canAccessCorporate = computed(() => Spark.roleOnCurrentTeam !== 'none');

    const canUseMessageHub = computed(() => canUseMessageHubUtil());

    const availableGroups = computed(() => {
        if (!Array.isArray(Spark.state.groups)) {
            console.error('Spark groups is not an array of groups.');
            return [];
        }
        const groups = Spark.state.groups;

        if (!currentGroup.value) {
            return groups;
        }

        // place current group on top of the list
        return groups.sort((a, b) => {
            if (a.group_id === currentGroup.value.group_id) {
                return -1;
            }
            if (b.group_id === currentGroup.value.group_id) {
                return 1;
            }
            return 0;
        });
    });

    const availableOrgUnits = computed(() => {
        if (!Array.isArray(Spark.state.orgUnits)) {
            console.error('Spark orgUnits is not an array of organizational units.');
            return [];
        }
        const orgUnits = Spark.state.orgUnits;

        if (!currentOrgUnit.value) {
            return orgUnits;
        }

        // place current org unit on top of the list
        return orgUnits.sort((a, b) => {
            if (a.id === currentOrgUnit.value.id) {
                return -1;
            }
            if (b.id === currentOrgUnit.value.id) {
                return 1;
            }
            return 0;
        });
    });

    const senderType = computed(() => {
        // TODO: Handle organizational unit context when OU functionality is implemented
        if (onCorporate()) {
            return SENDER_TYPE_CORPORATE;
        } else {
            return SENDER_TYPE_GROUP;
        }
    });

    return {
        canAccessCorporate,
        canUseMessageHub,
        currentOrgUnit,
        currentGroup,
        availableGroups,
        availableOrgUnits,
        getCurrentGroupId,
        onCorporate,
        roleOnCurrentGroup,
        roleOnCurrentOrgUnit,
        senderType,
    };
};
